import React from "react";
import type { RouteObject } from "react-router";
import { createBrowserRouter } from "react-router";
import { AuthenticationProvider } from "@/auth";
import Admin from "@/pages/Admin";
import Home from "@/pages/Home";
import { LoggedOut } from "@/pages/LoggedOut";
import { AdminRoutes } from "./AdminRoutes";

const routes = [
    {
        path: "/admin",
        element: (
            <AuthenticationProvider>
                <AdminRoutes />
            </AuthenticationProvider>
        ),
        children: [
            {
                path: "/admin",
                element: <Admin />,
            },
        ],
    },
    {
        path: "/logged-out",
        element: <LoggedOut />,
    },
    {
        path: "/",
        element: (
            <AuthenticationProvider>
                <Home />
            </AuthenticationProvider>
        ),
    },
] satisfies RouteObject[];

if (import.meta.env.DEV) {
    const ContactCenterDemo = React.lazy(() => import("./ContactCenterDemo"));

    routes.push({
        path: "/contact-center-demo",
        element: (
            <AuthenticationProvider>
                <ContactCenterDemo />
            </AuthenticationProvider>
        ),
    });
}

export const router = createBrowserRouter(routes);
